<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div *ngrxLet="connected$ as endpointsConnected" class="endpoints-connected-wrapper stats-component">
  <app-display-total-value
    title="{{'endpoints-connected.title' | translate}}"
    [total]="endpointsConnected"
    [loading]="loading$ | async">
  </app-display-total-value>
</div>
